import 'raf/polyfill';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/symbol';
import 'core-js/es6/weak-map';
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';

import './style/index.css';
// Fonts are loaded from index.php
// import './style/fonts/brandon.css';

import React from 'react';
import { Core } from 'module/Core';
import { getRouterReducer, stabilizers as routerStabilizers } from 'module/Redux/Router';
import { LoggerUtils } from 'module/Common';
import { MainLayout, stabilizers as viewStabilizers } from 'module/View';
import { MelezeApi } from 'module/Service/MelezeApi';
import { MelezeConfigMapper } from 'module/Service/MelezeConfig';
import { reducer as menuReducer } from 'module/Redux/Menu';
import { reducer as categoriesReducer } from 'module/Redux/Categories';
import { reducer as pageListReducer } from 'module/Redux/PageList';
import { reducer as postListReducer } from 'module/Redux/PostList';
import { reducer as pageReducer } from 'module/Redux/Page';
import { reducer as postReducer } from 'module/Redux/Post';
import { reducer as mainReducer, stabilizers as mainStabilizers } from 'module/Redux/Main';

declare global {
  interface Window {
    MelezeInject: any;
  }
}

window.onerror = error => {
  LoggerUtils.logError(error);
};

function bootApp(api: string) {
  try {
    const melezeConfig = MelezeConfigMapper.map(window.MelezeInject);
    // console.info(melezeConfig);
    const app = new Core();
    MelezeApi.configure(api + '/wp-json/meleze/v1', melezeConfig.prefetch);
    app.registerReducer('router', getRouterReducer(melezeConfig.routes, melezeConfig.preview));
    app.registerReducer('main', mainReducer);
    app.registerReducer('menu', menuReducer);
    app.registerReducer('categories', categoriesReducer);
    app.registerReducer('pageList', pageListReducer);
    app.registerReducer('page', pageReducer);
    app.registerReducer('postList', postListReducer);
    app.registerReducer('post', postReducer);
    app.registerStabilizers('router', routerStabilizers);
    app.registerStabilizers('view', viewStabilizers);
    app.registerStabilizers('main', mainStabilizers);
    // defined in inline script
    const hideLoader = (window as any).hideLoader;
    if (hideLoader) {
      hideLoader(() => {
        app.boot({
          appComponent: <MainLayout adminBar={melezeConfig.config.admin_bar} />,
          element: document.getElementById('root'),
        });
      });
    } else {
      app.boot({
        appComponent: <MainLayout adminBar={melezeConfig.config.admin_bar} />,
        element: document.getElementById('root'),
      });
    }
  } catch (error) {
    LoggerUtils.logError(error);
  }
}

// Dev only
// Get eveything for wordpress and inject it
// @ts-ignore
if (process.env.NODE_ENV !== 'production') {
  fetch('http://localhost:8000' + window.location.pathname + window.location.search)
    .then(res => res.text())
    .then(txt => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(txt, 'text/html');
      Array.from(doc.head.children).forEach(elem => {
        const importedElem = document.importNode(elem, true);
        document.head.appendChild(importedElem);
      });
      Array.from(doc.body.children).forEach(elem => {
        const importedElem = document.importNode(elem, true);
        if (importedElem.nodeName === 'SCRIPT') {
          const executableScript = document.createElement('script');
          executableScript.innerText = importedElem.innerHTML;
          document.head.appendChild(executableScript);
        } else {
          document.body.appendChild(importedElem);
        }
      });
    })
    .then(() => {
      window.requestAnimationFrame(() => {
        bootApp('http://localhost:8000');
      });
    });
} else {
  bootApp('');
}



// WEBPACK FOOTER //
// ./src/index.tsx